import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useEffect } from 'react'
import { SliceZone } from '@prismicio/react'
import { AdvertVisibilityType } from 'enums'

import { IContext } from 'components/AdvertsPage/types'
import { components } from 'slices'

import { getAdvertsPublic } from 'hooks/useAdvert/advert.service'

import { PageDocument } from 'types/prismic'
import { parseURLObject } from 'utils'
import { getFullSinglePage } from 'utils/prismic'
import withPageSettings from 'utils/withPageSettings'
import { AuthAccessLevel } from 'constants/auth'

const All = ({
  page,
  offset,
  initialAdverts
}: {
  page: PageDocument<string>
} & IContext) => {
  const router = useRouter()

  useEffect(() => {
    if (router.locale == 'en') {
      router.push('/job-ads')
    }
  }, [router])

  return (
    <SliceZone
      slices={page.data.slices}
      components={components}
      context={{
        initialAdverts,
        offset
      }}
    />
  )
}

const LIMIT = 9

export const getServerSideProps = withPageSettings(
  {
    auth: {
      accessLevel: AuthAccessLevel.Public
    }
  },
  async ({ locale: currentLocale, previewData, defaultLocale, query }) => {
    const locale = currentLocale || defaultLocale || 'lt'

    const pagePartsPromise = getFullSinglePage(
      'job_ads_page',
      { locale },
      { previewData }
    )
    const pageNumber = query.page as unknown as number
    const offset = pageNumber ? (pageNumber - 1) * LIMIT : 0

    const i18nPromise = serverSideTranslations(
      locale,
      ['inputs', 'crm', 'actions', 'ad', 'home_adverts', 'filters'],
      null
    )

    const initialFilter = parseURLObject(query?.adverts)

    const initialAdverts = await getAdvertsPublic({
      languageCode: locale,
      offset: offset,
      limit: LIMIT,
      statuses: [AdvertVisibilityType.Active],
      orderingColumn: 'dateCreated',
      order: 'desc',
      ...initialFilter
    })

    const [pageParts, i18n] = await Promise.all([pagePartsPromise, i18nPromise])
    const { page, ...layoutParts } = pageParts

    return {
      props: {
        ...i18n,
        page,
        initialAdverts,
        offset: pageNumber ? (pageNumber - 1) * 9 : 0,
        internal: {
          layout: {
            ...layoutParts
          }
        }
      },
      revalidate: 60 * 15 // 15 minutes
    }
  }
)

export default All
